import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {Observable} from "rxjs/Observable";
import {
    FORM_DIRECTIVES,
    FORM_PROVIDERS,
    FormControl,
    FormGroup,
    REACTIVE_FORM_DIRECTIVES,
    Validators
} from "@angular/forms";
import {AlertComponent, BS_VIEW_PROVIDERS, MODAL_DIRECTIVES, ModalDirective} from "ng2-bootstrap/ng2-bootstrap";
import {MailTemplate} from "../../domain/mailTemplate";
import {ActionTrigger} from "../../domain/actionTrigger";
import {ActionTriggerService} from "../../service/actionTrigger.service";
import {MailTemplateService} from "../../service/mailTemplate.service";
import {DEFAULT_ERROR_MESSAGES, EMAIL_VALIDATOR, INTEGER_VALIDATOR} from "../../validators/validators";
import {BankService} from "../../service/bank.service";
import {Bank} from "../../domain/bank";
import {MailReceiverTypeService} from "../../service/mailReceiverType.service";
import {MailReceiverType, MailReceiverTypeOption} from "../../domain/mailReceiverType";
import {SELECT_DIRECTIVES, SelectComponent} from "ng2-select/ng2-select";
import {MailTemplateProperty} from "../../domain/mailTemplateProperty";
import {MailTemplatePropertyService} from "../../service/mailTemplateProperty.service";
import {MailTemplateTagService} from "../../service/mailTemplateTag.service";
import {MailTemplateTag} from "../../domain/mailTemplateTag";

/**
 * .
 * Created by jlado on 13/9/16.
 */
@Component({
    selector: 'mailTemplate-editor',
    template: require('./mailTemplate.editor.component.html'),
    styles: [require('./mailTemplate.editor.component.css')],
    directives: [
        FORM_DIRECTIVES,
        REACTIVE_FORM_DIRECTIVES,
        AlertComponent,
        MODAL_DIRECTIVES,
        SELECT_DIRECTIVES
    ],
    providers: [
        FORM_PROVIDERS,
        BS_VIEW_PROVIDERS
    ],
})
export class MailTemplateEditorComponent implements OnInit, OnDestroy {

    @Input() public mailTemplate: MailTemplate;
    @Output() private close = new EventEmitter();

    @ViewChild('selectMailReceiverTypes') selectMailReceiverTypes: SelectComponent;
    @ViewChild('previewMailModal') previewMailModal: ModalDirective;

    private sub: any;

    public errorMessages: any;
    public form: FormGroup;

    public actionTriggers: ActionTrigger[];
    public banks: Bank[];
    public mailReceiverTypeOptions: Array<MailReceiverTypeOption>;
    public mailReceiverTypeOptionsSelected: Array<MailReceiverTypeOption>;
    public properties: MailTemplateProperty[];
    public tags: MailTemplateTag[];

    public createMode: boolean;

    public mailTemplateId: string;
    public mailTemplateTraduced: string;

    public errorMessage: string;
    public successMessage: string;

    public loading: boolean;

    public mailTemplateProperty: MailTemplateProperty;
    public mailTemplateTag: MailTemplateTag;

    constructor(private mailTemplateService: MailTemplateService,
                private bankService: BankService,
                private actionTriggerService: ActionTriggerService,
                private mailReceiverTypeService: MailReceiverTypeService,
                private mailTemplatePropertyService: MailTemplatePropertyService,
                private mailTemplateTagService: MailTemplateTagService,
                private route: ActivatedRoute) {
        this.init();
    }

    private init(): void {
        this.errorMessages = DEFAULT_ERROR_MESSAGES;

        this.loading = false;

        this.mailReceiverTypeOptions = [];
        this.mailReceiverTypeOptionsSelected = [];

        this.mailTemplate = new MailTemplate();

        this.mailTemplateProperty = new MailTemplateProperty();
        this.mailTemplateTag = new MailTemplateTag();

        this.mailTemplateTraduced = "";

        if (this.mailTemplate.templateBody == undefined) {
            this.mailTemplate.templateBody = "";
        }
    }

    private createFormGroup(): void {
        this.form = new FormGroup({
            action: new FormControl(this.mailTemplate.action, Validators.required),
            bank: new FormControl(this.mailTemplate.bank.name, Validators.required),
            receivers: new FormControl(this.mailTemplate.receivers, Validators.required),
            description: new FormControl(this.mailTemplate.description),
            periodicity: new FormControl(this.mailTemplate.periodicity, INTEGER_VALIDATOR),
            templateSubject: new FormControl(this.mailTemplate.templateSubject, Validators.required),
            copyTo: new FormControl(this.mailTemplate.copyTo, [EMAIL_VALIDATOR]),//Validators.required,
            templateBody: new FormControl(this.mailTemplate.templateBody, Validators.required),

            property: new FormControl(this.mailTemplateProperty),
            tag: new FormControl(this.mailTemplateTag)
        });
    }

    public ngOnInit() {
        this.createFormGroup();

        this.sub = this.route.params.subscribe(params => {
            let mailTemplateId = params['mailTemplateId'];
            if (mailTemplateId) {
                this.mailTemplateId = mailTemplateId;
                this.createMode = false;
            } else {
                this.mailTemplateId = null;
                this.createMode = true;
            }
            this.getData();
        });
    }

    private getData(): void {
        this.loading = true;
        this.errorMessage = null;

        let forkTasks: Observable<any>[] = [];
        forkTasks.push(this.bankService.getBanks());
        forkTasks.push(this.actionTriggerService.getActionTriggers());
        forkTasks.push(this.mailReceiverTypeService.getMailReceiverTypes());
        forkTasks.push(this.mailTemplatePropertyService.getMailTemplateProperties());
        forkTasks.push(this.mailTemplateTagService.getMailTemplateTags());
        if (this.mailTemplateId) {
            forkTasks.push(this.mailTemplateService.getMailTemplate(this.mailTemplateId));
        }
        Observable.forkJoin(forkTasks).subscribe(
            this.setData.bind(this),
            () => {
                this.bindError('Ocurrió un error al obtener los datos del correo.')
            });
    }

    private setData(data: any[]): void {
        this.loading = false;
        this.banks = data[0];
        this.actionTriggers = data[1];
        data[2].map((mailReceiverType: MailReceiverType) => this.mailReceiverTypeOptions
            .push(new MailReceiverTypeOption(mailReceiverType)));
        this.properties = data[3];
        this.tags = data[4];

        if (this.mailTemplateId) {
            this.mailTemplate = data[data.length - 1];

            if (!this.mailTemplate.action) {
                this.mailTemplate.action = new ActionTrigger(null);
            }
            if (!this.mailTemplate.bank) {
                this.mailTemplate.bank = new Bank(null);
            }
            if (this.mailTemplate.receivers) {
                this.mailTemplate.receivers
                    .forEach((mailReceiverType: MailReceiverType) => this.mailReceiverTypeOptionsSelected
                        .push(new MailReceiverTypeOption(mailReceiverType)));
            }
        } else {
            this.mailTemplate = new MailTemplate();
        }
    }

    public ngOnDestroy() {
        this.sub.unsubscribe();
    }

    private clearMessages(): void {
        this.successMessage = null;
        this.errorMessage = null;
    }

    public save(): void {
        this.clearMessages();
        this.loading = true;

        this.mailTemplateService.save(this.mailTemplate).subscribe(
            (saved: MailTemplate) => {
                this.loading = false;
                this.mailTemplate = saved;
                this.successMessage = 'El correo se guardó con éxito';
                this.updateViewAfterSave();
            },
            () => {
                this.bindError('Ocurrió un error al guardar los datos del correo.');
            });
    }

    private updateViewAfterSave(): void {
        if (this.createMode) {
            this.mailTemplate = new MailTemplate();
            this.mailReceiverTypeOptionsSelected = [];
            if (this.selectMailReceiverTypes) {
                this.selectMailReceiverTypes.active = [];
            }
        }
    }

    public goBack(event: any): void {
        event.preventDefault();
        this.close.emit(this.mailTemplate);

        window.history.back();
    }

    public mailReceiverTypesSelected(mailReceiverType: MailReceiverType): void {
        this.mailTemplate.receivers.push(mailReceiverType);
    }

    public mailReceiverTypesRemoved(mailReceiverType: MailReceiverType): void {
        let index = this.mailTemplate.receivers.map(
            function (mailReceiverType) {
                return mailReceiverType.id
            }).indexOf(mailReceiverType.id);
        if (index > -1) {
            this.mailTemplate.receivers.splice(index, 1);
        }
    }

    private bindError(messageError: string): void {
        this.loading = false;
        if (this.errorMessage == null) {
            this.errorMessage = messageError;
        } else {
            this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
        }
    }

    public setPropertyToTemplateBody(): void {
        if (this.mailTemplate.templateBody == undefined) {
            this.mailTemplate.templateBody = "";
        }
        if (this.mailTemplateProperty.tag != undefined) {
            this.mailTemplate.templateBody = this.mailTemplate.templateBody + this.mailTemplateProperty.tag;
        }
    }

    public setTagToTemplateBody(): void {
        if (this.mailTemplate.templateBody == undefined) {
            this.mailTemplate.templateBody = "";
        }
        if (this.mailTemplateTag.startTag != undefined && this.mailTemplateTag.finishTag != undefined) {
            this.mailTemplate.templateBody = this.mailTemplate.templateBody + this.mailTemplateTag.startTag + this.mailTemplateTag.finishTag;
        }
    }

    public createPreviewMailTemplate(): void {
        this.clearMessages();
        this.loading = true;

        let templateBody: string = this.mailTemplate.templateBody;

        if (templateBody.length == 0 || templateBody == undefined) {
            templateBody = "VACÍO."
        }

        this.mailTemplateService.previewMailTemplate(templateBody).subscribe(
            (mailTemplateTraduced: MailTemplate) => {
                this.loading = false;
                this.mailTemplateTraduced = mailTemplateTraduced.templateBody.toString();
                this.previewMailModal.show();
            },
            () => {
                this.bindError('Ocurrió un error al generar la vista previa.');
                this.loading = false;
            });
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/config/mailConfig/mailTemplate.editor.component.ts
 **/